export const ADS_IMAGES = [
  "/media/safti-banner.jpg",
  "/media/safti-banner-1.png",
  "/media/safti-banner-2.png",
];
